import React, { useState, useEffect } from "react";
import { Box, Container, Typography, Button, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Buffer } from "buffer";
import Iframe from "../../components/iframe";
import { Loader } from "../../components/loading";
import { registerParticipant } from "../../redux/actions/UserActions";
import { useDispatch, useSelector } from 'react-redux'

const PAYMONGO_SECRET = "sk_test_S3hmLTNKd67hs5yfaQeiiGok";
const PAYMONGO_KEY = "pk_test_teiH3q8PD2VXeGyJQWTCtS41";

const PaymentGateway = ({ formData, setActiveStep, selectedPayment, selectedTicket, setRegisterStatus, handleBack, eventId }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [sourceId, setSourceId] = useState("");
    const [paymentPending, setPaymentPending] = useState(false);
    const [showNext, setShowNext] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const [number, setNumber] = useState("");
    const [name, setName] = useState("");
    const [focus, setFocus] = useState("");
    const [month, setMonth] = useState("00");
    const [year, setYear] = useState("00");

    const [cvc, setCvc] = useState("");
    const [clientKey, setClientKey] = useState("");
    const [price, setPrice] = useState(0);
    const [has3ds, setHas3ds] = useState(false);
    const [paymentIntentId, setPaymentIntentId] = useState("");

    const dispatch = useDispatch()
    const state = useSelector((state) => state)


    useEffect(() => {
        getPrice()
    }, []);


    const handlePaymentSuccess = (res) => {
        try {
            const payload = {
                ...formData,
                selectedPayment,
                selectedTicket,
                transaction: res,
                event: eventId
            }

            dispatch(registerParticipant(payload)).then(() => {
                // PROCEED TO NEXT PAGE
                setRegisterStatus('success')
                setActiveStep((prevStep) => prevStep + 1);

            }).catch((err) => {
                // RETRY'
                console.log(err)
                handlePaymentFail()
            })
        } catch (error) {
            console.error(error)
        }


    }

    const handlePaymentFail = (err) => {
        handleBack()
    }

    const getPrice = () => {
        const amount = selectedTicket.price * 100;
        // console.log(amount)
        // setPrice(amount)
        setLoading(true);

        if (selectedTicket.type === "card") {
            createPaymentIntent(amount);
        } else {
            createSource(amount);
        }
    };

    const createPaymentIntent = async (amount) => {
        setPaymentPending(true);

        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Basic ${Buffer.from(
                    `${PAYMONGO_SECRET}:Luis Ramirez`
                ).toString("base64")}`,
            },
            body: JSON.stringify({
                data: {
                    attributes: {
                        amount,
                        payment_method_allowed: [
                            "atome",
                            "card",
                            "dob",
                            "paymaya",
                        ],
                        payment_method_options: {
                            card: { request_three_d_secure: "any" },
                        },
                        currency: "PHP",
                        capture_type: "automatic",
                        description: "1 Month Subscription",
                    },
                },
            }),
        };

        fetch("https://api.paymongo.com/v1/payment_intents", options)
            .then((response) => response.json())
            .then((response) => {
                setPaymentIntentId(response.data.id);
                setClientKey(response.data.attributes.client_key);

                createPaymentMethod(response.data.attributes.client_key);
            })
            .catch((err) => console.error(err));
    };

    const createPaymentMethod = async (client_key) => {
        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Basic ${Buffer.from(
                    `${PAYMONGO_SECRET}:Luis Ramirez`
                ).toString("base64")}`,
            },
            body: JSON.stringify({
                data: {
                    attributes: {
                        details: {
                            card_number: number,
                            exp_month: parseInt(month),
                            exp_year: parseInt(year),
                            cvc,
                        },
                        billing: {
                            name: formData.name + " " + formData.lastName,
                            email: formData.email,
                        },
                        type: "card",
                    },
                },
            }),
        };

        fetch("https://api.paymongo.com/v1/payment_methods", options)
            .then((response) => response.json())
            .then((response) => {
                console.log("response.data.id", response.data.id);

                attachPaymentMethod(response.data.id, client_key);
            })
            .catch((err) => console.error(err));
    };

    const attachPaymentMethod = (paymentMethodId, clientKey) => {
        // This PaymentMethod ID must be created before the attach action. This is just a sample value to represent a PaymentMethod
        // PaymentIntent client_key example
        // Get the payment intent id from the client key
        const paymentIntentId = clientKey.split("_client")[0];
        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Basic ${Buffer.from(
                    `${PAYMONGO_SECRET}:Luis Ramirez`
                ).toString("base64")}`,
            },
            body: JSON.stringify({
                data: {
                    attributes: {
                        client_key: clientKey,
                        payment_method: paymentMethodId,
                        // currency: 'PHP',
                        // amount: price,
                        // payment_method_options: {card: {request_three_d_secure: 'any'}},
                    },
                },
            }),
        };

        fetch(
            `https://api.paymongo.com/v1/payment_intents/${paymentIntentId}/attach`,
            options
        )
            .then((response) => response.json())
            .then((response) => {
                console.log(response);
                const paymentIntentStatus = response.data.attributes.status;

                if (paymentIntentStatus === "awaiting_next_action") {
                    // Render your modal for 3D Secure Authentication since next_action has a value. You can access the next action via paymentIntent.attributes.next_action.
                    setPaymentPending(false);
                    setRedirectLink(
                        response.data.attributes.next_action.redirect.url
                    );
                    setSourceId(response.data.id);
                    setHas3ds(true);

                    setTimeout(() => {
                        setPaymentPending(true);
                    }, 1000);
                    getStatusOfIntent(response.data.id, price);

                    // handleResponse(response.data.attributes.next_action, response.data.id, price)
                } else if (paymentIntentStatus === "succeeded") {
                    // You already received your customer's payment. You can show a success message from this condition.
                    setPaymentPending(false);
                    setLoading(true);
                    handlePaymentSuccess()

                } else if (paymentIntentStatus === "awaiting_payment_method") {
                    // The PaymentIntent encountered a processing error. You can refer to paymentIntent.attributes.last_payment_error to check the error and render the appropriate error message.
                    handlePaymentFail(response)
                } else if (paymentIntentStatus === "processing") {
                    handlePaymentFail(response)
                    // You need to requery the PaymentIntent after a second or two. This is a transitory status and should resolve to `succeeded` or `awaiting_payment_method` quickly.
                }
            })
            .catch((err) => console.error(err));
    };
    const getStatusOfIntent = async (id, price) => {
        const interval = setInterval(() => {
            checkPaymentIntent();
        }, 5000);
        let checkPaymentIntent = async () => {
            const options = {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Basic ${Buffer.from(
                        `${PAYMONGO_KEY}:Luis Ramirez`
                    ).toString("base64")}`,
                },
            };

            try {
                const url = `https://api.paymongo.com/v1/payment_intents/${paymentIntentId}?client_key=${clientKey}`;
                const response = await fetch(url, options);
                const responseJson = await response.json();
                const paymentIntentStatus = responseJson.data.attributes.status;

                if (paymentIntentStatus === "succeeded") {
                    setLoading(true);
                    // createPayment(id, price)
                    clearInterval(interval);
                    setPaymentPending(false);
                    handlePaymentSuccess()

                    // You already received your customer's payment. You can show a success message from this condition.
                } else if (paymentIntentStatus === "awaiting_payment_method") {
                    handlePaymentFail(paymentIntentStatus)
                    // The PaymentIntent encountered a processing error. You can refer to paymentIntent.attributes.last_payment_error to check the error and render the appropriate error message.
                } else if (paymentIntentStatus === "processing") {
                    handlePaymentFail(paymentIntentStatus)
                    // You need to requery the PaymentIntent after a second or two. This is a transitory status and should resolve to `succeeded` or `awaiting_payment_method` quickly.
                }
            } catch (e) { }
        };
    };

    const createSource = async (amount) => {
        // CREATE SOURCE
        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Basic ${Buffer.from(
                    `${PAYMONGO_KEY}:Luis Ramirez`
                ).toString("base64")}`,
            },
            body: JSON.stringify({
                data: {
                    attributes: {
                        redirect: {
                            success: window.location.origin + "/payment/success",
                            failed: window.location.origin + "/payment/failed",
                        },
                        amount,
                        currency: "PHP",
                        type: selectedPayment.type,
                        billing: {
                            name: formData.name + " " + formData.lastName,
                            email: formData.email,
                        },
                    },
                },
            }),
        };
        // console.log(paymentType, props.data.firstName + props.data.lastName, props.data.email);

        fetch("https://api.paymongo.com/v1/sources", options)
            .then((response) => response.json())
            .then((response) =>
                handleResponse(
                    response.data.attributes.redirect.checkout_url,
                    response.data.id,
                    amount
                )
            )
            .catch((err) => console.error(err));
    };

    const handleResponse = async (url, id, price) => {
        // console.log('handleResponse', id)
        setRedirectLink(url);
        setSourceId(id);
        setPaymentPending(true);
        await getStatusOfPayment(id, price);
    };

    const getStatusOfPayment = async (id, price) => {
        const interval = setInterval(() => {
            checkSource();
        }, 5000);

        let checkSource = async () => {
            const options = {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    Authorization: `Basic ${Buffer.from(
                        `${PAYMONGO_KEY}:Luis Ramirez`
                    ).toString("base64")}`,
                },
            };

            try {
                const response = await fetch(
                    `https://api.paymongo.com/v1/sources/${id}`,
                    options
                );
                const responseJson = await response.json();
                if (responseJson.data.attributes.status === "chargeable") {
                    // TRANSFER PAYMENT TO PAYMONGO
                    // props.setIsLoading(true);
                    createPayment(id, price);
                    clearInterval(interval);
                }
            } catch (e) { }
        };
    };

    const createPayment = async (id, price) => {
        const options = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Basic ${Buffer.from(
                    `${PAYMONGO_SECRET}:Luis Ramirez`
                ).toString("base64")}`,
            },
            body: JSON.stringify({
                data: {
                    attributes: {
                        amount: price,
                        currency: "PHP",
                        source: { id, type: "source" },
                        description: "Fellowship Night Accompanying Person",
                    },
                },
            }),
        };
        setLoading(true);

        fetch("https://api.paymongo.com/v1/payments", options)
            .then((response) => response.json())
            .then((res) => {
                setPaymentPending(false);
                // setLoading(false)
                handlePaymentSuccess(res)
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
                handlePaymentFail(err)
            });
    };



    useEffect(() => {
        const handleMessage = (event) => {
            // Optional: check origin for security
            // if (event.origin !== 'https://your-domain.com') return;

            const { type, payload } = event.data;

            if (type === 'PAYMENT_SUCCESS') {
                console.log('Payment success:', payload);
                // handlePaymentComplete(); // your function
            }

            if (type === 'PAYMENT_FAILED') {
                console.log('Payment failed');
                handlePaymentFail()
                // handleRetryOrError(); // your function
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);


    return (
        <>
            {/* <Modal
                open={paymentPending}
                onClose={() => {
                    setLoading(false);
                    setPaymentPending(false);
                }}
                className="customModal"
            >
                <div
                    style={{
                        height: "100%",
                        margin: 20,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                >
                    <Iframe source={redirectLink} />
                </div>
            </Modal> */}
            {/* {loading && <Loader />} */}

            <Container maxWidth="md">
                {paymentPending && (
                    <Box
                        sx={{
                            height: "60vh",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexDirection: "column",
                        }}
                    >
                        <Iframe source={redirectLink} />
                    </Box>)
                }
                {/* <Box mt={4} mb={4}>
                    <Typography variant="h5" align="center">
                        Payment Gateway
                    </Typography>
                </Box>

                <Typography align="center" sx={{ mb: 2 }}>
                    Click the button below to proceed with your payment.
                </Typography>

                <Button fullWidth variant="contained" color="primary" onClick={handlePayment}>
                    Pay Now
                </Button> */}
            </Container>
        </>

    );
};

export default PaymentGateway;
